const PRED_PREFIX = "/pred";

export const ROUTES = {
  HOME: "/",
  PRED: PRED_PREFIX,
  DETAIL: `${PRED_PREFIX}/detail`,
  CREATEPOOL: `${PRED_PREFIX}/createpool`,
  MYCREATEDPOLLS: `${PRED_PREFIX}/mycreatedpolls`,
  MYPREDICTION: `${PRED_PREFIX}/myprediction`,
  POINTS_BREAKDOWN: `${PRED_PREFIX}/points-breakdown`,
  OLD_DETAIL: "/detail",
  OLD_CREATEPOOL: "/createpool",
  OLD_MYCREATEDPOLLS: "/mycreatedpolls",
  OLD_MYPREDICTION: "/myprediction",
  OLD_POINTS_BREAKDOWN: "/points-breakdown",
  PRIVATEMARKET: "/privatemarket",
  USER_PROFILE: `${PRED_PREFIX}/user-profile`,
  BLOG: "/blog",
  BLOG_DETAIL: "/blog-detail",
  GET_RAIN: "/get-rain",
  TERMS: "/terms",
  PRIVACY: "/privacy-policy",
  ABOUT: "/about-us",
  BRAND_ASSETS: "/brand-assets",
  NOT_FOUND: "/404",
  APPS: "/apps",
  BUILDERS: "/builders",
  APP_DETAIL: "/apps/:id",
  LIQUIDITY: "/liquidity",
  GENERATEMARKET: "/generatemarket",
};

export const detailPath = (id) => `${ROUTES.DETAIL}?id=${id}`;
export const createPoolPath = (poolType) =>
  `${ROUTES.CREATEPOOL}?poolType=${poolType}`;

export const PUBLIC_BASE_URL = "https://www.rain.one";
